import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useGetNotificationsQuery, selectAllTheNotifications, allNewNotificationsSeen } from 'context/notification/notificationsApiSlice';
import { IconButton, Icon, Badge, Drawer } from '@mui/material';
import useAlert from "hooks/useAlert";
import NewMessage from "assets/sounds/open-ended.mp3";

import Notifications from './NotificationsList';

export default function NotificationsDrawer({navbarIconButton, iconsStyle}) {
  const [state, setState] = useState(false);
  const [notifications,setNotifications] = useState([]);
  const [notificationsNum,setNotificationsNum] = useState(0);
  const allNotifs = useSelector(selectAllTheNotifications);
  const dispatch = useDispatch();
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState(open);
  };
  const { showAlerts } = useAlert(); 
  const audioPlayer = useRef(null);
  
  // Fetch notifications using the generated hook
  const { data, isSuccess, isLoading, isError, Error } = useGetNotificationsQuery({filters : JSON.stringify({seen : 0, type :"alert"})},{
    pollingInterval: 10000,
    skip: state
  });

  useEffect(() => {
    /* eslint-disable */
    setNotifications(
      allNotifs?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    );
  }, [allNotifs])

  useEffect(() => {
    /* eslint-disable */
    isError ? showAlerts({
      title : "Dashboard Alert",
      type  : "toast",
      msg :  Error?.error || Error?.message,
      color :"error"
    }) : null
  }, [isError,Error]);

  
  useEffect(() => {
    let numUnseenNotifications = notifications.filter(n => n.seen === false).length;
    let numNewNotifications = notifications.filter(n => n.isNew === true).length;
    setNotificationsNum(numUnseenNotifications);
    if (numNewNotifications > 0) {
      dispatch(allNewNotificationsSeen(notifications));
      audioPlayer.current.muted = false;
      audioPlayer.current?.play()
    }
  }, [notifications]);

  return (
        <>
          <IconButton 
          onClick={toggleDrawer(true)} 
          size="small"
          disableRipple
          sx={navbarIconButton}
          variant="contained"
          >
            <Badge  badgeContent={notificationsNum} color="error">
              <audio muted ref={audioPlayer} src={NewMessage} />
              <Icon sx={iconsStyle}>notifications</Icon>
            </Badge>
          </IconButton>
          <Drawer
            anchor="right"
            open={state}
            onClose={toggleDrawer(false)}
            sx={{"& .MuiDrawer-paper" : {m:0, borderRadius : 0, p : 1 , width : {xs: "100vw", lg : 360, height:"100vh"}}}}
          >
              <Notifications 
                unReadNotificationsNum={notificationsNum}
                unreadNotifs={notifications}
                showAlerts={showAlerts}
                iconsStyle={iconsStyle}
                toggleDrawer={toggleDrawer}
              />
          </Drawer>
        </>
  );
}
